<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.6638 24.4849L24.3202 20.8284L27.1486 23.6568L23.4922 27.3133L20.6638 24.4849ZM18.0732 24.2477C18.0806 24.2398 18.0881 24.2321 18.0958 24.2244L23.6131 18.7071C24.0036 18.3166 24.6368 18.3166 25.0273 18.7071L29.27 22.9497C29.6605 23.3402 29.6605 23.9734 29.27 24.3639L24.2222 29.4117C24.2149 29.4195 24.2073 29.4273 24.1997 29.435L10.3638 43.2708C9.97329 43.6613 9.34012 43.6613 8.9496 43.2708L4.70696 39.0282C4.31643 38.6377 4.31643 38.0045 4.70696 37.614L18.0732 24.2477Z"
            fill="currentColor" />
        <path
            d="M18.1562 13.875L16.2812 18L14.4062 13.875L10.2812 12L14.4062 10.125L16.2812 6L18.1562 10.125L22.2812 12L18.1562 13.875Z"
            fill="currentColor" />
        <path
            d="M38.5 14.5L36 20L33.5 14.5L28 12L33.5 9.5L36 4L38.5 9.5L44 12L38.5 14.5Z"
            fill="currentColor" />
        <path
            d="M37.875 33.875L36 38L34.125 33.875L30 32L34.125 30.125L36 26L37.875 30.125L42 32L37.875 33.875Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
